/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as customersSlice from './customersSlice';

export default function* watchCustomersSaga() {
 yield takeLatest(customersSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(customersSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(customersSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(customersSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(customersSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(customersSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  customersSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  customersSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  customersSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  customersSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  customersSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
